import { render, staticRenderFns } from "./WillBeneficiariesManagingFinancesDetails.vue?vue&type=template&id=c85b0dbc"
import script from "./WillBeneficiariesManagingFinancesDetails.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesManagingFinancesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports